import { useEffect, useState } from 'react';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

export function useSystemName() {
  const [systemName, setSystemName] = useState<string>('CAMO26');

  useEffect(() => {
    const fetchSystemName = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/settings/public/system-name`);
        const name = response.data.systemName || 'CAMO26';
        setSystemName(name);

        // Update document title
        document.title = name;
      } catch (error) {
        console.error('Failed to fetch system name:', error);
        // Keep default
      }
    };

    fetchSystemName();
  }, []);

  return systemName;
}
